import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { isSoundOn, onSoundChange, playBlip, setSoundOn } from "../utils/sound";

export const SoundToggle = ({ className = "", testid = "sound-toggle" }) => {
  const [on, setOn] = useState(isSoundOn());
  const reduce = useReducedMotion();

  useEffect(() => onSoundChange(setOn), []);

  const toggle = () => {
    const next = !on;
    setSoundOn(next);
    if (next) setTimeout(() => playBlip(520), 30);
  };

  return (
    <button
      type="button"
      data-testid={testid}
      aria-pressed={on}
      aria-label={on ? "Mute interface sound" : "Enable interface sound"}
      title={on ? "Sound on" : "Sound off"}
      onClick={toggle}
      className={`relative inline-flex h-10 w-10 items-center justify-center rounded-full border transition-colors duration-300 ${
        on
          ? "border-volt/60 text-volt"
          : "border-ink/15 text-ink hover:border-ink/45"
      } ${className}`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={on ? "on" : "off"}
          initial={reduce ? false : { scale: 0.4, opacity: 0, rotate: -30 }}
          animate={{ scale: 1, opacity: 1, rotate: 0 }}
          exit={reduce ? undefined : { scale: 0.4, opacity: 0, rotate: 30 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="flex"
        >
          {on ? <Volume2 className="h-4.5 w-4.5" /> : <VolumeX className="h-4.5 w-4.5" />}
        </motion.span>
      </AnimatePresence>
      {on && !reduce && (
        <motion.span
          aria-hidden="true"
          className="absolute inset-0 rounded-full border border-volt/50"
          animate={{ scale: [1, 1.35], opacity: [0.7, 0] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: "easeOut" }}
        />
      )}
    </button>
  );
};
